import React, { useState } from "react";
import { useSelector } from "react-redux";
import { ChevronRight } from "lucide-react";
import { useQuery } from "react-query";

import { getRotate } from "@/api/Dashboard/dashboard";
import Fetching from "@/components/Fetching/Fetching";
import DashboardRotateTable from "./RotateTable/DashboardRotateTable";

import classes from "./dashboard-rotate.module.scss";

export default function DashboardRotate({ filters }) {
	const { estate_parent_id, estate_id, type_currency } = useSelector((s) => s.auth.filter);

	const [openIdx, setOpenIdx] = useState(null);
	const [modalLabel, setModalLabel] = useState("");
	const [modalOpen, setModalOpen] = useState(false);
	const [modalProducts, setModalProducts] = useState([]);

	const { data, isLoading } = useQuery(["dashboard_rotate", { ...filters, estate_parent_id, estate_id }], () =>
		getRotate({ ...filters, estate_parent_id, estate_id }),
	);
	const fmt = (v) =>
		new Intl.NumberFormat("es-CL", {
			style: "currency",
			currency: "CLP",
			maximumFractionDigits: 0,
		}).format(v);

	if (isLoading) {
		return <Fetching topMargin="5em" bottomMargin="5em" />;
	}

	const periods = data.response.periods.filter((p) => p.products.length > 0);
	const totalQty = periods.reduce((sum, p) => sum + p.quantity, 0);
	const totalVal = periods.reduce((sum, p) => sum + (type_currency === "CLP" ? p.total_value_locale : p.total_value_usd), 0);

	const toggle = (i) => setOpenIdx(openIdx === i ? null : i);
	const openModal = (label, products) => {
		setModalLabel(label);
		setModalProducts(products);
		setModalOpen(true);
	};
	const closeModal = () => setModalOpen(false);

	return (
		<div className={classes.wrapper}>
			<table className={classes.table}>
				<thead className={classes.header}>
					<tr>
						<th>Período</th>
						<th className={classes.right}>Cant. Envases</th>
						<th className={classes.right}>Valor</th>
					</tr>
				</thead>
				<tbody>
					{periods.map((p, i) => {
						const expanded = openIdx === i;
						const preview = p.products.slice(0, 5);

						return (
							<React.Fragment key={p.label}>
								<tr className={classes.periodRow} onClick={() => toggle(i)} aria-expanded={expanded}>
									<td>
										<ChevronRight size={16} className={`${classes.icon} ${expanded ? classes.rotated : ""}`} />
										{p.label}
									</td>
									<td className={classes.right}>{p.quantity}</td>
									<td className={classes.right}>{type_currency === "CLP" ? fmt(p.total_value_locale) : fmt(p.total_value_usd)}</td>
								</tr>
								{expanded && (
									<tr>
										<td colSpan={3} className={classes.detailCell} style={{ padding: 0 }}>
											<table className={classes.detailTable}>
												<thead>
													<tr>
														<th>Producto</th>
														<th className={classes.right}>Cant.</th>
														<th className={classes.right}>Valor</th>
														<th>Campo</th>
														<th>Bodega</th>
														<th>Últ. uso</th>
													</tr>
												</thead>
												<tbody>
													{preview.map((pr, idx) => (
														<tr key={idx}>
															<td className={classes.productName}>{pr.name}</td>
															<td className={classes.right}>{pr.quantity}</td>
															<td className={classes.right}>
																{type_currency === "CLP" ? fmt(pr.total_value_locale) : fmt(pr.total_value_usd)}
															</td>
															<td>{pr.estate.parent_name}</td>
															<td>{pr.estate.name}</td>
															<td>{pr.last_move ? new Date(pr.last_move).toLocaleDateString("es-CL") : ""}</td>
														</tr>
													))}
													{p.products.length > 5 && (
														<tr>
															<td colSpan={6} className={classes.moreCell}>
																<button className={classes.moreBtn} onClick={() => openModal(p.label, p.products)}>
																	Ver más
																</button>
															</td>
														</tr>
													)}
												</tbody>
											</table>
										</td>
									</tr>
								)}
							</React.Fragment>
						);
					})}
				</tbody>
				<tfoot>
					<tr className={classes.totalRow}>
						<td>Total sin movimiento</td>
						<td className={classes.right}>{totalQty}</td>
						<td className={classes.right}>{fmt(totalVal)}</td>
					</tr>
				</tfoot>
			</table>

			{data.response.alert_percent > 0 && (
				<div className={classes.alert}>
					<strong>Alerta:</strong> El {data.response.alert_percent}% del inventario sin movimiento en 90 días.
				</div>
			)}

			{modalOpen && <DashboardRotateTable periodLabel={modalLabel} modalProducts={modalProducts} closeModal={closeModal} />}
		</div>
	);
}
